/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, limit: NonNullable<unknown> }} Team_Manager_Seats_UsedInputs */



/**
* | output |
* | --- |
* | "{used} of {limit} seats used" |
*
* @param {Team_Manager_Seats_UsedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_seats_used = /** @type {((inputs: Team_Manager_Seats_UsedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Seats_UsedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.used} sur ${i?.limit} places utilisées`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} von ${i?.limit} Plätzen belegt`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.used} di ${i?.limit} postazioni in uso`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Занято мест: ${i?.used} из ${i?.limit}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.used} de ${i?.limit} puestos en uso`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已使用 ${i?.used}/${i?.limit} 个席位`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.limit} 席中 ${i?.used} 席を使用中`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.limit} में से ${i?.used} सीटें इस्तेमाल में`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.used} de ${i?.limit} lugares utilizados`)
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.limit} seats used`)
});